"use client"
import React from 'react';
import {ShoppingBasket, Star} from "lucide-react";
import AddToBasketButton from "@/app/product/[slug]/_component/desktop/addToBasketButton";
import TotalQuantityCardComponent from "@/components/totalQuantityCardComponent";
import ProductWish from "@/app/product/[slug]/_component/product-wish";
import ProductShare from "@/app/product/[slug]/_component/product-share";
import AvailableButtonDesktop from "@/app/product/[slug]/_component/desktop/available-button-desktop";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {IProductDetailsProps} from "@/interface/components/product/product-details";
import SellerInfo from "@/app/product/[slug]/_component/desktop/seller-info";
import PriceInfo from "@/app/product/[slug]/_component/desktop/price-info";
import SnappPayMobile from "@/app/product/[slug]/_component/mobile/snapp-pay-mobile";


function PricingAddToBasketComponent({data, mediaData}: { data: IProductDetailsProps, mediaData: any }) {

    return (
        <>
            {data?.productItem ? (
                <div className="w-[450px] flex flex-wrap content-start  h-full">
                    <div className='w-full flex flex-wrap items-center justify-end gap-1'>
                        <ProductWish price={data?.productItem?.sale_price} title={data?.product?.title}
                                     id={String(data?.product?.id)} unique_id={data?.product?.unique_id}/>
                        <ProductShare/>
                    </div>
                    <section
                        className="w-full flex-wrap flex  content-between p-2 px-4 rounded-2xl bg-background-shoppingCard mt-4 border h-[420px]">
                        <SellerInfo data={data}/>
                        <PriceInfo data={data}/>
                        <div
                            className="w-full flex   flex-wrap  border-gray-200 items-center justify-between">
                            <div className="w-full flex flex-wrap pb-4 text-sm text-blue-secondary">
                                {data?.product?.order_count > 0 ? (
                                    <div className="w-1/2 mb-2 flex items-center gap-1 justify-start">
                                        <ShoppingBasket className={"w-5 h-5"}/>
                                        <span className="text-xs font-bold">
                                        در سبد خرید {data?.product?.order_count.toLocaleString("fa")} نفر
                                    </span>
                                    </div>
                                ) : null}
                                <div className='w-full items-center justify-center flex flex-wrap'>
                                    <AddToBasketButton product={
                                        {
                                            sale_price: data?.productItem?.sale_price,
                                            product_item_id: String(data?.productItem?.id),
                                            unique_id: data?.product?.unique_id,
                                            slug: data?.product?.slug,
                                            id: String(data?.product?.id),
                                            title: data?.product?.title,
                                            quantity: 1,
                                            seller_title: String(data?.productItem?.seller?.title),
                                            discount_percentage: data?.productItem?.discount_percentage,
                                            price: data?.productItem?.price,
                                            image: mediaData?.[0]?.url,
                                            active: true,
                                            max_basket_limit: data?.productItem?.max_basket_limit || 0,
                                            min_total_qty_and_max_basket_qty: data?.productItem?.min_total_qty_and_max_basket_qty || 0
                                        }
                                    }/>
                                </div>
                                <div
                                    className={`w-1/2 flex mt-2 font-medium text-xs ${data?.product?.order_count > 0 ? "justify-end" : "justify-start"}`}>
                                    <TotalQuantityCardComponent count={Number(data?.productItem?.total_quantity)}/>
                                </div>
                            </div>

                        </div>
                        <SnappPayMobile data={data?.productItem?.sale_price}/>
                        <div className="w-full text-sm text-blue-secondary flex flex-wrap">
                            {data?.productItem?.guarantee && (
                                <div className="w-1/2 grow flex gap-1">
                                    <div className="text-gray-400"> {SingleProductEnum.guarantee}:</div>
                                    <div title={data.productItem.guarantee.title}
                                         className={"truncate grow"}>{data.productItem.guarantee.title}</div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            ) : (
                <div className={"w-[450px] flex flex-wrap content-start h-full"}>
                    <div className='w-full flex flex-wrap items-center justify-end gap-1'>
                        <ProductWish price={data?.productItem?.sale_price} title={data?.product?.title}
                                     id={String(data?.product?.id)} unique_id={data?.product?.unique_id}/>
                        <ProductShare/>
                    </div>
                    <div
                        className={"w-full flex-wrap flex  p-2 px-4 rounded-2xl bg-background-shoppingCard mt-4 border h-[340px]"}>
                        <div
                            className="w-full h-[76px] flex flex-wrap border-b  border-gray-200 items-center justify-between">

                            <div className=" flex items-center justify-end gap-1">
                                <Star className={"text-amber-400 fill-amber-400"}/>
                                <div>
                            <span
                                className="text-lg font-bold">{data?.product?.rate_average?.toLocaleString("fa")}</span>
                                    <span className="text-sm text-gray-400 ps-1">
                                ({SingleProductEnum?.star}
                                        <span className="px-0.5">
                                    {
                                        data?.productComments ? (Object.values(data?.productComments)?.length)?.toLocaleString("fa") : null
                                    }
                                </span>
                                        {SingleProductEnum?.customer})
                            </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className={"h-[150px] flex flex-col justify-center border-b text-lg leading-7 font-medium"}>
                            {SingleProductEnum?.noExistProduct}
                        </div>
                        <AvailableButtonDesktop unique_id={data?.product?.unique_id}/>
                    </div>
                </div>
            )}
        </>
    )
}

export default PricingAddToBasketComponent;


